/**
 * Utilidades de fecha límite (fechaCierre) de una vacante.
 * Solo aplica a procesos activos: borrador/cerrado no marcan nada.
 */

// Días antes de la fecha límite en que el aviso se pone amarillo
export const DEADLINE_WARNING_DAYS = 7;

const toDate = (ts) => {
  if (!ts) return null;
  if (ts._seconds) return new Date(ts._seconds * 1000);
  if (ts.seconds) return new Date(ts.seconds * 1000);
  if (typeof ts.toDate === 'function') return ts.toDate();
  const d = new Date(ts);
  return Number.isNaN(d.getTime()) ? null : d;
};

/**
 * @returns {null | { level: 'warning'|'overdue', daysLeft: number }}
 *  - null: sin aviso (sin fecha, proceso no activo, o falta más de una semana)
 *  - warning (amarillo): quedan 1..DEADLINE_WARNING_DAYS días
 *  - overdue (rojo): cierra hoy (daysLeft 0) o ya pasó (daysLeft negativo)
 */
export const getDeadlineInfo = (position) => {
  if (position?.status !== 'active') return null;

  const deadline = toDate(position?.fechaCierre);
  if (!deadline) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const deadlineDay = new Date(deadline);
  deadlineDay.setHours(0, 0, 0, 0);

  const daysLeft = Math.round((deadlineDay - today) / 86400000);

  if (daysLeft <= 0) return { level: 'overdue', daysLeft };
  if (daysLeft <= DEADLINE_WARNING_DAYS) return { level: 'warning', daysLeft };
  return null;
};
